import Wrapper from './_views/Wrapper.vue';

const IrRefunds = () => import('./_views/IrRefunds.vue');
const IrRefund = () => import('./_views/IrRefund.vue');

const parentRouteConfig = {
  name: 'Refunds',
  to: {
    name: 'refunds',
    query: {
      pageNum: '1',
    },
  },
};

export default [
  {
    path: '/refunds',
    component: Wrapper,
    children: [
      {
        path: '',
        name: 'refunds',
        component: IrRefunds,
        meta: {
          title: 'Refunds',
          navigation: {
            position: 6,
            name: 'Refunds',
            icon: 'assignment_return',
            to: {
              name: 'refunds',
              query: {
                pageNum: '1',
              },
            },
          },
        },
      },
      {
        path: ':id',
        name: 'refund',
        component: IrRefund,
        meta: {
          title: 'Refund',
          parent: parentRouteConfig,
        },
      },
    ],
  },
];
